import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthenticatedUser } from '@/types/auth';

interface AuthState {
  user: AuthenticatedUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpiresAt: number | null;
  setSession: (input: {
    user: AuthenticatedUser;
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
  }) => void;
  setTokens: (input: {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
  }) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      accessTokenExpiresAt: null,
      setSession: ({ user, accessToken, refreshToken, expiresInSeconds }) =>
        set({
          user,
          accessToken,
          refreshToken,
          accessTokenExpiresAt: Date.now() + expiresInSeconds * 1000,
        }),
      setTokens: ({ accessToken, refreshToken, expiresInSeconds }) =>
        set({
          accessToken,
          refreshToken,
          accessTokenExpiresAt: Date.now() + expiresInSeconds * 1000,
        }),
      clear: () =>
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          accessTokenExpiresAt: null,
        }),
    }),
    {
      name: 'imtithal-auth',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        accessTokenExpiresAt: state.accessTokenExpiresAt,
      }),
    },
  ),
);
